import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_3 = {
  class: "",
  style: {"display":"flex","align-items":"center"}
}

import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'
import {
  ref,
  computed,
  nextTick,
  PropType,
} from 'vue'
import FormItem from './FormItem.vue'
import { applyLocaleLabelWidthToFormOpt } from './applyLocaleLabelWidth'
import {
  ActionType,
  FormSize,
  FormSizeType,
  ActionColOpt,
  FormItemOpt,
  FormOpt,
  GlobalOpt,
  RowOpt,
  FormType,
  FormActionType,
} from './types'
import { formItemPopoverOpt } from './globalOpt'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  formColumns: {
    type: Object,
    required: true,
  },
  modelValue: {
    type: Object,
    required: true,
  },
  formSize: {
    type: String as PropType<FormSizeType>,
    default: FormSize.Default,
  },
  formOpt: {
    type: Object as PropType<FormOpt>,
    default: () => ({} as FormOpt),
  },
  formItemOpt: {
    type: Object as PropType<FormItemOpt>,
    default: () => ({}),
  },
  rowOpt: {
    type: Object as PropType<RowOpt>,
    default: () => ({}),
  },
  actionColOpt: {
    type: Object as PropType<ActionColOpt>,
    default: () => ({style:'position:relative;top:20px;'}),
  },
  groupType: {
    type: String as PropType<'tabs' | 'other'>,
    default: 'other',
  },
  collapseOpt: {
    type: Object,
    default: () => ({}),
  },
  collapseActive: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
  tabsFormColumns: {
    type: Array as PropType<any>,
    default: () => [],
  },
  tabsOpt: {
    type: Object,
    default: () => ({}),
  },
  opeRowOpt: {
    type: Object,
    default: () => ({}),
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  groupFormColumns: {
    type: Array as PropType<any>,
    default: () => [],
  },
  globalOpt: {
    type: Object as PropType<GlobalOpt>,
    default: () => ({}),
  },
  formType: {
    type: String as PropType<FormActionType>,
    default: FormActionType.Form,
  },
},
  emits: [
  ActionType.Submit,
  ActionType.Query,
  ActionType.ResetQuery,
  ActionType.Reset,
  'update:formType',
  'update:disabled',
  'update:loading',
  'update:modelValue',
],
  setup(__props, { expose: __expose, emit: __emit }) {

const { t, locale } = useI18n()
const props = __props
const collapseActive = ref<string[]>(props.collapseActive || [])
const formSize = ref(props.formSize)
const ruleFormRef = ref()
const emit = __emit
// 根据formItem类型是数组还是对象转换prop
const getKey = computed(
  () => (key: number | keyof typeof props.modelValue, formItem: { prop?: string }) =>
    (Array.isArray(props?.formColumns) && formItem.prop) || key,
)

/** 随语言调整 label-width，其余 formOpt 原样透传 el-form */
const elFormBindOpt = computed(() =>
  applyLocaleLabelWidthToFormOpt(props.formOpt, locale.value),
)
const formType = computed({
  get: () => props.formType || 'form',
  set: (val) => {
    emit('update:formType', val)
  },
})
// 整个表单的禁用启用
const disabledForm = computed({
  get: () => props.disabled,
  set: (val) => {
    emit('update:disabled', val)
  },
})
const loadingForm = computed({
  get: () => props.loading,
  set: (val) => {
    emit('update:loading', val)
  },
})
// 表单数据的双向绑定
const form = computed({
  get: () => props.modelValue || {},
  set: (val) => {
    emit('update:modelValue', val)
  },
})
// 表单提交
const handleSubmit = async () => {
  await nextTick()
  return ruleFormRef.value?.validate().catch((err: any) => false)
}
// 表单重置
const handleReset = () => {
  ruleFormRef.value?.resetFields?.()
  ruleFormRef.value?.clearValidate?.()
}
// 表单的其他按钮的相关操作
const handleFormAction = (type: string, formRef?: FormInstance | undefined) => {
  console.log(ruleFormRef, 'ruleFormRef')
  const types: any = {
    [ActionType.Submit]: () => {
      formRef?.validate((valid: any) => {
        valid && ((loadingForm.value = true), emit('update:disabled', true))
        emit(
          ActionType.Submit,
          valid,
          (ok: boolean, message?: string, normalClick?: boolean) => {
            console.log('ok', ok);
            if (normalClick) {
              loadingForm.value = false
              emit('update:disabled', false)
            } else {
              !props.formOpt.skipSubmitMsg && ElMessage({
                type: ok ? 'success' : 'error',
                message: message ?? (ok ? t('cmform.operationSuccess') : t('cmform.operationFailed')),
              });
              loadingForm.value = false
              emit('update:disabled', false)
            }
          },
        )
      })
    },
    [ActionType.Reset]: () => {
      emit(ActionType.Reset)
      // setTimeout(() => {
      //   formRef?.resetFields?.()
      // }, 10)
    },
    [ActionType.Query]: () => {
      emit(ActionType.Query)
    },
    [ActionType.ResetQuery]: () => {
      formRef?.resetFields?.()
      emit(ActionType.ResetQuery)
    },
  }
  types?.[type]?.()
}
__expose({
  ruleFormRef,
  handleSubmit,
  handleReset,
})

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, _mergeProps({
    ref_key: "ruleFormRef",
    ref: ruleFormRef,
    model: form.value,
    size: formSize.value,
    onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
    disabled: disabledForm.value
  }, elFormBindOpt.value), {
    default: _withCtx(() => [
      _createVNode(_component_el_row, _normalizeProps(_guardReactiveProps({gutter: 10,...__props.rowOpt})), {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formColumns, (formItem, key) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: getKey.value(key, formItem)
            }, [
              _createVNode(_component_el_popover, _mergeProps({ ref_for: true }, {..._unref(formItemPopoverOpt),...formItem.popoverOpt}, {
                disabled: !formItem.disabledPopover
              }), {
                reference: _withCtx(() => [
                  _createVNode(FormItem, {
                    formItem: formItem,
                    prop: getKey.value(key, formItem),
                    modelValue: form.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form).value = $event)),
                    globalOpt: __props.globalOpt
                  }, _createSlots({
                    [`${getKey.value(key,formItem)}-top-label`]: _withCtx(() => [
                      _renderSlot(_ctx.$slots, getKey.value(key,formItem) + '-top-label', {
                        formItem: formItem,
                        prop: getKey.value(key,formItem)
                      })
                    ]),
                    [`${getKey.value(key,formItem)}-bottom-label`]: _withCtx(() => [
                      _renderSlot(_ctx.$slots, getKey.value(key,formItem) + '-bottom-label', {
                        formItem: formItem,
                        prop: getKey.value(key,formItem)
                      })
                    ]),
                    default: _withCtx(() => [
                      (formItem.slot)
                        ? _renderSlot(_ctx.$slots, getKey.value(key, formItem), {
                            key: 0,
                            prop: getKey.value(key, formItem),
                            formItem: formItem
                          })
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, [
                    (formItem.footerSlot)
                      ? {
                          name: `${getKey.value(key,formItem)}-footer`,
                          fn: _withCtx(() => [
                            _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-footer', {
                              prop: getKey.value(key, formItem),
                              formItem: formItem
                            })
                          ]),
                          key: "0"
                        }
                      : undefined,
                    (formItem.labelSlot)
                      ? {
                          name: `${getKey.value(key,formItem)}-label`,
                          fn: _withCtx(() => [
                            _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-label', {
                              prop: getKey.value(key, formItem),
                              formItem: formItem,
                              label: formItem.label
                            })
                          ]),
                          key: "1"
                        }
                      : undefined
                  ]), 1032, ["formItem", "prop", "modelValue", "globalOpt"])
                ]),
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-popoverContent')
                ]),
                _: 2
              }, 1040, ["disabled"]),
              _renderSlot(_ctx.$slots, "default", {}, () => [
                (formItem.colTip)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(formItem.colTip), 1))
                  : _createCommentVNode("", true)
              ])
            ], 64))
          }), 128)),
          (__props.groupFormColumns?.length)
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 0,
                span: 24
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_collapse, _mergeProps({
                    modelValue: collapseActive.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((collapseActive).value = $event)),
                    accordion: ""
                  }, __props.collapseOpt), {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groupFormColumns, (item) => {
                        return (_openBlock(), _createBlock(_component_el_collapse_item, _mergeProps({
                          title: item.title,
                          name: item.name,
                          key: item.name,
                          ref_for: true
                        }, item.collapseItemOpt), {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                              _createTextVNode(_toDisplayString(item.title) + " ", 1),
                              _renderSlot(_ctx.$slots, `${item.name}-collapse-append`)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, `${item.name}-collapse-item-slot`, {}, () => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.formColumns, (formItem, key) => {
                                return (_openBlock(), _createBlock(_component_el_col, _mergeProps({
                                  key: getKey.value(key, formItem),
                                  ref_for: true
                                }, formItem.colOpt || { span: 12 }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_popover, _mergeProps({ ref_for: true }, {..._unref(formItemPopoverOpt),...formItem.popoverOpt}, {
                                      disabled: !formItem.disabledPopover
                                    }), {
                                      reference: _withCtx(() => [
                                        _createVNode(FormItem, {
                                          formItem: formItem,
                                          prop: getKey.value(key, formItem),
                                          modelValue: form.value,
                                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form).value = $event)),
                                          globalOpt: __props.globalOpt
                                        }, _createSlots({
                                          default: _withCtx(() => [
                                            (formItem.slot)
                                              ? _renderSlot(_ctx.$slots, getKey.value(key, formItem), {
                                                  key: 0,
                                                  prop: getKey.value(key, formItem),
                                                  formItem: formItem
                                                })
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, [
                                          (formItem.footerSlot)
                                            ? {
                                                name: `${getKey.value(key,formItem)}-footer`,
                                                fn: _withCtx(() => [
                                                  _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-footer', {
                                                    prop: getKey.value(key, formItem),
                                                    formItem: formItem
                                                  })
                                                ]),
                                                key: "0"
                                              }
                                            : undefined,
                                          (formItem.labelSlot)
                                            ? {
                                                name: `${getKey.value(key,formItem)}-label`,
                                                fn: _withCtx(() => [
                                                  _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-label', {
                                                    prop: getKey.value(key, formItem),
                                                    formItem: formItem,
                                                    label: formItem.label
                                                  })
                                                ]),
                                                key: "1"
                                              }
                                            : undefined
                                        ]), 1032, ["formItem", "prop", "modelValue", "globalOpt"])
                                      ]),
                                      default: _withCtx(() => [
                                        _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-popoverContent')
                                      ]),
                                      _: 2
                                    }, 1040, ["disabled"])
                                  ]),
                                  _: 2
                                }, 1040))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1040, ["title", "name"]))
                      }), 128))
                    ]),
                    _: 3
                  }, 16, ["modelValue"])
                ]),
                _: 3
              }))
            : _createCommentVNode("", true),
          (__props.groupType === 'tabs' && __props.tabsFormColumns?.length)
            ? (_openBlock(), _createBlock(_component_el_col, {
                key: 1,
                span: 24
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tabs, _mergeProps({ type: "border-card" }, __props.tabsOpt), {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabsFormColumns, (item) => {
                        return (_openBlock(), _createBlock(_component_el_tab_pane, _mergeProps({
                          label: item.label,
                          key: item.label,
                          ref_for: true
                        }, item.tabPaneOpt), {
                          label: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createTextVNode(_toDisplayString(item.label) + " ", 1),
                              _renderSlot(_ctx.$slots, `${item.name}-tab-append`)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, `${item.name}-tab-item-slot`, {}, () => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.formColumns, (formItem, key) => {
                                return (_openBlock(), _createBlock(_component_el_col, _mergeProps({
                                  key: getKey.value(key, formItem),
                                  ref_for: true
                                }, formItem.colOpt || { span: 12 }), {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_popover, _mergeProps({ ref_for: true }, {..._unref(formItemPopoverOpt),...formItem.popoverOpt}, {
                                      disabled: !formItem.disabledPopover
                                    }), {
                                      reference: _withCtx(() => [
                                        _createVNode(FormItem, {
                                          formItem: formItem,
                                          prop: getKey.value(key, formItem),
                                          modelValue: form.value,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form).value = $event)),
                                          globalOpt: __props.globalOpt
                                        }, _createSlots({
                                          default: _withCtx(() => [
                                            (formItem.slot)
                                              ? _renderSlot(_ctx.$slots, getKey.value(key, formItem), {
                                                  key: 0,
                                                  prop: getKey.value(key, formItem),
                                                  formItem: formItem
                                                })
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, [
                                          (formItem.footerSlot)
                                            ? {
                                                name: `${getKey.value(key,formItem)}-footer`,
                                                fn: _withCtx(() => [
                                                  _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-footer', {
                                                    prop: getKey.value(key, formItem),
                                                    formItem: formItem
                                                  })
                                                ]),
                                                key: "0"
                                              }
                                            : undefined,
                                          (formItem.labelSlot)
                                            ? {
                                                name: `${getKey.value(key,formItem)}-label`,
                                                fn: _withCtx(() => [
                                                  _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-label', {
                                                    prop: getKey.value(key, formItem),
                                                    formItem: formItem,
                                                    label: formItem.label
                                                  })
                                                ]),
                                                key: "1"
                                              }
                                            : undefined
                                        ]), 1032, ["formItem", "prop", "modelValue", "globalOpt"])
                                      ]),
                                      default: _withCtx(() => [
                                        _renderSlot(_ctx.$slots, getKey.value(key, formItem) + '-popoverContent')
                                      ]),
                                      _: 2
                                    }, 1040, ["disabled"])
                                  ]),
                                  _: 2
                                }, 1040))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1040, ["label"]))
                      }), 128))
                    ]),
                    _: 3
                  }, 16)
                ]),
                _: 3
              }))
            : _createCommentVNode("", true),
          (formType.value === _unref(FormActionType).Query)
            ? (_openBlock(), _createBlock(_component_el_col, _normalizeProps(_mergeProps({ key: 2 }, { span: 24, ...__props.actionColOpt })), {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (handleFormAction(_unref(ActionType).Query))),
                        size: formSize.value,
                        loading: loadingForm.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('cmform.query')), 1)
                        ]),
                        _: 1
                      }, 8, ["size", "loading"]),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-search",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (handleFormAction(_unref(ActionType).ResetQuery, ruleFormRef.value))),
                        size: formSize.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('cmform.resetQuery')), 1)
                        ]),
                        _: 1
                      }, 8, ["size"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 16))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 16),
      (formType.value === _unref(FormActionType).Form)
        ? (_openBlock(), _createBlock(_component_el_row, _normalizeProps(_mergeProps({ key: 0 }, { justify: 'end', ...__props.opeRowOpt })), {
            default: _withCtx(() => [
              _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps({ span: 5, ...__props.actionColOpt })), {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, _mergeProps({
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (handleFormAction(_unref(ActionType).Reset, ruleFormRef.value)))
                  }, __props.formOpt?.cancelBtnOpt, { size: formSize.value }), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.formOpt?.cancelText || _ctx.$t('common.cancel')), 1)
                    ]),
                    _: 1
                  }, 16, ["size"]),
                  _createVNode(_component_el_button, _mergeProps({
                    type: "primary",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (handleFormAction(_unref(ActionType).Submit, ruleFormRef.value))),
                    loading: loadingForm.value,
                    size: formSize.value
                  }, __props.formOpt?.confirmBtnOpt), {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.formOpt?.confirmText || _ctx.$t('common.confirm')), 1)
                    ]),
                    _: 1
                  }, 16, ["loading", "size"])
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }, 16))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 16, ["model", "size", "disabled"]))
}
}

})